import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import EditableRow from './EditableRow';
/* import EditModal from './EditModal'; */
import DeleteConfirmationModal from 'routes/Pages/FichasTecnicas/Components/DeleteConfirmationModal';
import { reformatDateYYYYmmDD } from 'routes/Pages/FichasTecnicas/ConstsAndUtils/utils';
import EditModal2 from './EditModal2';
import { TEXT_COLOR_FT } from 'config/config';
import { Grid, InputAdornment, TextField } from '@material-ui/core';
import { Search } from '@material-ui/icons';

import TablePagination from '@material-ui/core/TablePagination';
import { putEquipamientoFicha } from 'services/api';


const useStyles = makeStyles({
  table: {
    minWidth: 650,
    //  border: 'solid 1px',
    borderColor: '#e0e0e0'
  },
});

const DataTable = ({ headCells, rows, handleSave, handleDelete, reloadTable, autoridades }) => {
  const classes = useStyles();
  const [editRowIndex, setEditRowIndex] = useState(null);
  const [editedRowData, setEditedRowData] = useState({});
  const [openModal, setOpenModal] = useState(false)

  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [searchQuery, setSearchQuery] = useState('');


  const [showModalDelete, setShowModalDelete] = useState(false)
  const [dataToDelete, setDataToDelete] = useState('')

  const [checkedHorario, setCheckHorario] = useState(false)

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);

  const handleChange = () => {
    setCheckHorario(!checkedHorario)
  }

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setPage(0);
  };

  const filteredRows = React.useMemo(
    () =>
      rows.filter((row) =>
        Object.values(row).some((value) =>
          value?.toString().toLowerCase().includes(searchQuery.toLowerCase())
        )
      ),
    [rows, searchQuery]
  );


  const handleSort = (key) => {
    setSortConfig((prev) => ({
      key,
      direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc',
    }));
  };

  const sortedRows = React.useMemo(() => {
    if (!sortConfig.key) return filteredRows;

    return [...filteredRows].sort((a, b) => {
      if (a[sortConfig.key] < b[sortConfig.key]) {
        return sortConfig.direction === 'asc' ? -1 : 1;
      }
      if (a[sortConfig.key] > b[sortConfig.key]) {
        return sortConfig.direction === 'asc' ? 1 : -1;
      }
      return 0;
    });
  }, [filteredRows, sortConfig]);

  const paginatedRows = React.useMemo(() => {
    const start = page * rowsPerPage;
    const end = start + rowsPerPage;
    return sortedRows.slice(start, end);
  }, [sortedRows, page, rowsPerPage]);



  const openModalDelete = (row) => {
    setShowModalDelete(true)
    setDataToDelete(row)
  }

  const closeModal = () => {
    setOpenModal(false)
  }



  const handleEditClick = (row) => {

    setEditedRowData(row)
    setOpenModal(true)
  };

  const closeModalDelete = () => {
    setShowModalDelete(false)
  }

  const handleSaveClick = (data) => {
    const dataRestructure = {
      ...data,
      garantia_vigente: data.garantia_vigente === "SI" ? true : false,
      fecha_exp_garantia: data.garantia_vigente === "SI" ? data.fecha_exp_garantia ? data.fecha_exp_garantia : null : null,
    }

    putEquipamientoFicha(dataRestructure, data.id)
      .then(res => {

        reloadTable()
      })
      .catch(e => console.error(e))
      .finally(f => { })
    setOpenModal(false)
  };

  const handleDeleteClick = () => {
    handleDelete(dataToDelete)
    closeModalDelete()
  }

  const handleInputChange = (e, id, type) => {

    switch (type) {
      case 'number': const regexNumber = /^[0-9]+$/;
        if (regexNumber.test(e.target.value) || e.target.value === '') {
          if (e.target.value.length < 12) {
            setEditedRowData({ ...editedRowData, [id]: e.target.value });
          }
        }
        break
      default: if (e.target.value.length < 100) {
        setEditedRowData({ ...editedRowData, [id]: e.target.value });
      }
        break
    }
  };

  return (
    <>
      <Grid xs={12} container item justifyContent='flex-end' style={{ padding: 0 }}>

        <TextField
          size='small'
          label="Buscar"
          variant="outlined"
          value={searchQuery}
          onChange={handleSearchChange}
          style={{ marginBottom: 5 }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Search />
              </InputAdornment>
            ),
          }}
        />

      </Grid>
      <TableContainer >
        <Table className={classes.table} aria-label="simple table">
          <TableHead style={{ backgroundColor: "#f4f4f7", }}>
            <TableRow>
              {headCells.map((headCell) => {

                if (headCell.shown) {
                  return (
                    <TableCell
                      key={headCell.id}
                      align={headCell.align || 'left'}
                      style={{ color: TEXT_COLOR_FT, cursor: 'pointer' }}
                      onClick={() => { handleSort(headCell.id) }}
                    >
                      <Grid container alignItems='center'>
                        <Grid container item xs={11}>
                          {headCell.label}
                        </Grid>
                        <Grid container item xs={1}>
                          <span>
                            {sortConfig.key === headCell.id
                              ? sortConfig.direction === 'asc'
                                ? ' 🔼'
                                : ' 🔽'
                              : ''}
                          </span>
                        </Grid>
                      </Grid>


                    </TableCell>
                  )
                } else {
                  return null
                }
              })}
              <TableCell align="center">Acciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedRows.map((row, index) => {
              const rowIndex = page * rowsPerPage + index;
              return (
                <EditableRow
                  key={row.id || rowIndex}
                  row={editRowIndex === rowIndex ? editedRowData : row}
                  headCells={headCells}
                  isEditing={false}
                  isEditable={true}
                  onInputChange={(e, id, type) => handleInputChange(e, id, type)}
                  onSave={handleSaveClick}
                  onDelete={() => openModalDelete(row)}
                  onEdit={() => handleEditClick(row)}
                />
              );
            })}
          </TableBody>

        </Table>
      </TableContainer>
      <TablePagination
        component="div"
        count={sortedRows.length}
        page={page}
        onPageChange={(event, newPage) => setPage(newPage)}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={(event) => {
          setRowsPerPage(parseInt(event.target.value, 10));
          setPage(0);
        }}
        rowsPerPageOptions={[10, 25, 50, 100]}
        labelRowsPerPage="Filas por página"
      />

      <EditModal2
        openDialog={openModal}
        close={closeModal}
        dataCrear={editedRowData}
        postData={handleSaveClick}
        autoridades={autoridades}
      />
      <DeleteConfirmationModal
        openDialog={showModalDelete}
        close={closeModalDelete}
        postData={handleDeleteClick}
        deleteData={dataToDelete}
        loading={false}
      />
    </>

  );
};

DataTable.propTypes = {
  headCells: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      align: PropTypes.oneOf(['left', 'right', 'center', 'justify']),
    })
  ).isRequired,
  rows: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default DataTable;
